"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NextArrow = exports.PrevArrow = exports.getSliderIndicator = void 0;

require("slick-carousel/slick/slick.css");

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _triangleLeft = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/triangle-left"));

var _triangleRight = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/triangle-right"));

var _const = require("../../const");

var _carousel = require("./carousel.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getSliderIndicator = function getSliderIndicator(index) {
  return /*#__PURE__*/_react.default.createElement(_carousel.CarouselIndicatorItem, {
    key: "slide_".concat(index),
    "data-test": _const.TestType.BUTTON,
    "data-test-id": _const.TestValue.AEM_CAROUSEL_DOT
  }, /*#__PURE__*/_react.default.createElement(_carousel.CarouselIndicatorItemDot, null));
}; // eslint-disable-next-line @typescript-eslint/no-empty-function


exports.getSliderIndicator = getSliderIndicator;

var PrevArrow = function PrevArrow(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? false : _ref$top;
  return /*#__PURE__*/_react.default.createElement(_carousel.Arrow, {
    className: "slick-control prev",
    onClick: onClick,
    top: top,
    "data-test": _const.TestType.BUTTON,
    "data-test-id": _const.TestValue.AEM_CAROUSEL_PREV
  }, /*#__PURE__*/_react.default.createElement(_triangleLeft.default, {
    measure: 16,
    mr: 2,
    color: "black"
  }));
}; // eslint-disable-next-line @typescript-eslint/no-empty-function


exports.PrevArrow = PrevArrow;

var NextArrow = function NextArrow(_ref2) {
  var _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      _ref2$top = _ref2.top,
      top = _ref2$top === void 0 ? false : _ref2$top;
  return /*#__PURE__*/_react.default.createElement(_carousel.Arrow, {
    className: "slick-control next",
    right: true,
    onClick: onClick,
    top: top,
    "data-test": _const.TestType.BUTTON,
    "data-test-id": _const.TestValue.AEM_CAROUSEL_NEXT
  }, /*#__PURE__*/_react.default.createElement(_triangleRight.default, {
    measure: 16,
    color: "black"
  }));
};

exports.NextArrow = NextArrow;

var UIComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(UIComponent, _React$Component);

  var _super = _createSuper(UIComponent);

  function UIComponent() {
    var _this;

    _classCallCheck(this, UIComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "slider", void 0);

    _defineProperty(_assertThisInitialized(_this), "isPaused", !_this.props.autoplay);

    return _this;
  }

  _createClass(UIComponent, [{
    key: "removeAriaHidden",
    value: function removeAriaHidden() {
      var _this$slider, _this$slider$innerSli, _this$slider$innerSli2, _this$slider$innerSli3;

      // @ts-ignore
      var slides = ((_this$slider = this.slider) === null || _this$slider === void 0 ? void 0 : (_this$slider$innerSli = _this$slider.innerSlider) === null || _this$slider$innerSli === void 0 ? void 0 : (_this$slider$innerSli2 = _this$slider$innerSli.track) === null || _this$slider$innerSli2 === void 0 ? void 0 : (_this$slider$innerSli3 = _this$slider$innerSli2.node) === null || _this$slider$innerSli3 === void 0 ? void 0 : _this$slider$innerSli3.querySelectorAll('.slick-slide')) || [];
      slides.forEach(function (elem) {
        elem.removeAttribute('aria-hidden');
      });
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var _this2 = this;

      var settings = _objectSpread({
        autoplay: this.props.autoplay,
        dots: true,
        pauseOnHover: !this.props.autopauseDisabled,
        speed: 400,
        autoplaySpeed: this.props.delay || 2000,
        prevArrow: /*#__PURE__*/_react.default.createElement(PrevArrow, null),
        nextArrow: /*#__PURE__*/_react.default.createElement(NextArrow, null),
        infinite: true,
        lazyLoad: 'ondemand',
        afterChange: function afterChange() {
          return _this2.removeAriaHidden();
        },
        onReInit: function onReInit() {
          return _this2.removeAriaHidden();
        },
        appendDots: function appendDots(dots) {
          return /*#__PURE__*/_react.default.createElement(_carousel.CarouselPauseControlWrap, null, /*#__PURE__*/_react.default.createElement("ul", {
            className: "slick-dots"
          }, dots), _this2.props.autoplay && /*#__PURE__*/_react.default.createElement(_carousel.CarouselPauseControl, {
            color: "secondaryLight",
            "data-test": _const.TestType.BUTTON,
            "data-test-id": _this2.isPaused ? _const.TestValue.AEM_CAROUSEL_PLAY : _const.TestValue.AEM_CAROUSEL_PAUSE,
            onClick: function onClick() {
              _this2.isPaused ? _this2.slider.slickPlay() : _this2.slider.slickPause();
              _this2.isPaused = !_this2.isPaused;

              _this2.slider.forceUpdate();
            }
          }, _this2.isPaused ? /*#__PURE__*/_react.default.createElement(_triangleRight.default, {
            measure: 12,
            color: "white",
            ml: 2
          }) : /*#__PURE__*/_react.default.createElement("svg", {
            viewBox: "0 0 45.975 45.975",
            height: "10px"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.987,0c-2.762,0-5,2.239-5,5v35.975c0,2.763,2.238,5,5,5s5-2.238,5-5V5C18.987,2.238,16.75,0,13.987,0z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M31.987,0c-2.762,0-5,2.239-5,5v35.975c0,2.762,2.238,5,5,5s5-2.238,5-5V5C36.987,2.239,34.749,0,31.987,0z"
          }))));
        },
        customPaging: function customPaging(index) {
          return getSliderIndicator(index);
        }
      }, this.props.settings);

      if (this.slider && this.props.autoplay) {
        this.slider.slickPlay();
      }

      return /*#__PURE__*/_react.default.createElement(_carousel.CarouselContainer, {
        transparent: this.props.transparent,
        inverse: this.props.inverse,
        arrowStyle: this.props.arrowStyle,
        arrowColor: this.props.arrowColor,
        "data-test": _const.TestType.COMPONENT,
        "data-test-id": _const.TestValue.AEM_CAROUSEL_UI
      }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, settings, {
        ref: function ref(slider) {
          return _this2.slider = slider;
        }
      }), _react.default.Children.map(this.props.children, function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_carousel.CarouselItem, {
          key: "slide_".concat(index)
        }, item);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderCarousel();
    }
  }]);

  return UIComponent;
}(_react.default.Component);

var _default = UIComponent;
exports.default = _default;